/* ============================================================
   THE SHOE LADA: theme behaviour
   Vanilla JS. Talks to Shopify's AJAX Cart API (/cart/*.js).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money ---------- */
  var MONEY_FORMAT = (window.SL_SETTINGS && window.SL_SETTINGS.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    cents = cents || 0;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = dollars + '.' + parts[1];
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, out);
  }
  window.SLformatMoney = formatMoney;

  var FREE_SHIP_THRESHOLD = (window.SL_SETTINGS && window.SL_SETTINGS.freeShipThreshold) || 4499; // cents

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- cart drawer ---------- */
  var drawer = $('#sl-drawer');
  var overlay = $('#sl-overlay');

  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); overlay.classList.add('is-open'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); } }
  window.SLopenCart = openDrawer;

  function renderCart(cart) {
    if (!drawer) return;
    // count
    $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    // ship meter
    var remaining = Math.max(0, FREE_SHIP_THRESHOLD - cart.total_price);
    var pct = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
    var fill = $('#sl-ship-fill'); if (fill) fill.style.width = pct + '%';
    var msg = $('#sl-ship-msg');
    if (msg) {
      msg.innerHTML = remaining <= 0
        ? '🎉 You unlocked FREE shipping!'
        : "You're " + formatMoney(remaining) + ' away from FREE shipping';
    }
    // items
    var wrap = $('#sl-cart-items');
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="sl-empty">' +
        '<div class="sl-archivo sl-up" style="font-weight:700;font-size:15px;color:#15160F;margin-bottom:6px">Your cart’s empty</div>' +
        '<div style="font-size:14px">Pick a kit and start saving.</div></div>';
    } else {
      wrap.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
        return '<div class="sl-li">' +
          '<div class="sl-li__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div style="flex:1;min-width:0">' +
            '<div class="sl-li__t">' + it.product_title + '</div>' +
            '<div class="sl-li__p">' + formatMoney(it.final_price) + '</div>' +
            '<div class="sl-stepper" data-key="' + it.key + '">' +
              '<button type="button" data-change="' + (it.quantity - 1) + '">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-change="' + (it.quantity + 1) + '">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="sl-li__rm" type="button" data-key="' + it.key + '" data-change="0">Remove</button>' +
        '</div>';
      }).join('');
    }
    // subtotal
    var sub = $('#sl-subtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
    var coBtn = $('#sl-checkout'); if (coBtn) coBtn.textContent = 'Checkout · ' + formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { openDrawer(); return cart; });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------- global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open/close cart
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-cart-close]') || t === overlay) { closeDrawer(); return; }

    // add to cart (any element with data-add-id = variant id)
    var addEl = t.closest('[data-add-id]');
    if (addEl) {
      e.preventDefault();
      var id = addEl.getAttribute('data-add-id');
      var qtyInput = addEl.getAttribute('data-qty-from');
      var qty = 1;
      if (qtyInput) { var qi = $(qtyInput); if (qi) qty = parseInt(qi.value, 10) || 1; }
      if (id) addToCart(id, qty);
      return;
    }

    // line stepper / remove
    var changeBtn = t.closest('[data-change]');
    if (changeBtn) {
      var holder = changeBtn.closest('[data-key]') || changeBtn;
      var key = holder.getAttribute('data-key');
      var q = parseInt(changeBtn.getAttribute('data-change'), 10);
      if (key) changeLine(key, q);
      return;
    }

    // accordion
    var accBtn = t.closest('.sl-acc__btn');
    if (accBtn) {
      var item = accBtn.closest('.sl-acc__item');
      var open = item.classList.contains('is-open');
      var group = accBtn.closest('.sl-acc');
      if (group) $all('.sl-acc__item', group).forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.sl-acc__sign').textContent = '+'; });
      if (!open) { item.classList.add('is-open'); accBtn.querySelector('.sl-acc__sign').textContent = '–'; }
      return;
    }

    // gallery thumb
    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var main = $('#sl-gallery-main');
      if (main) main.src = thumb.getAttribute('data-thumb');
      $all('[data-thumb]', thumb.closest('.sl-thumbs')).forEach(function (b) { b.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
  });

  /* ---------- qty steppers on product page ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = $(b.getAttribute('data-qty-target'));
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------- Build Your Kit selector ---------- */
  function initKitSelector(root) {
    var opts = $all('.sl-opt', root);
    var galleries = $all('[data-kit-gallery]', root);
    var atc = $('[data-kit-atc]', root);
    function select(opt, idx) {
      opts.forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      galleries.forEach(function (g, i) {
        var on = (i === idx);
        g.classList.toggle('is-active', on);
        if (on) g.scrollLeft = 0;
      });
      if (atc) {
        atc.setAttribute('data-add-id', opt.getAttribute('data-variant'));
        var price = opt.getAttribute('data-price');
        atc.textContent = 'Add to cart · ' + formatMoney(parseInt(price, 10));
      }
    }
    opts.forEach(function (o, i) { o.addEventListener('click', function () { select(o, i); }); });
    var prev = $('[data-kit-prev]', root), next = $('[data-kit-next]', root);
    function scrollByDir(dir) {
      var g = root.querySelector('[data-kit-gallery].is-active');
      if (g) g.scrollBy({ left: dir * g.clientWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    var preIdx = 0;
    opts.forEach(function (o, i) { if (o.classList.contains('is-active')) preIdx = i; });
    if (opts[preIdx]) select(opts[preIdx], preIdx);
  }
  $all('[data-kit-selector]').forEach(initKitSelector);

  /* ---------- before / after slider ---------- */
  $all('[data-ba]').forEach(function (ba) {
    var range = ba.querySelector('input[type=range]');
    var before = ba.querySelector('.sl-ba__before');
    var divider = ba.querySelector('.sl-ba__divider');
    if (!range) return;
    range.addEventListener('input', function () {
      var v = range.value + '%';
      if (before) before.style.width = v;
      if (divider) divider.style.left = v;
    });
  });

  /* ---------- sticky ATC ---------- */
  var sticky = $('#sl-sticky');
  if (sticky) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      if (y > 600 && !(drawer && drawer.classList.contains('is-open'))) sticky.classList.add('is-on');
      else sticky.classList.remove('is-on');
    }, { passive: true });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', fetchCart);
  fetchCart();
})();
